import { createTheme } from "@mui/material/styles";

// Loophole brand palette — single source of truth for MUI components.
// CSS-module surfaces mirror these via :root tokens in src/index.css.
export const loopholeColors = {
  primary: "#0B4FB5",
  primaryDark: "#09408a",
  primaryLight: "#537bb7",
  accentCyan: "#40fbff",
  text: "#0b2540",
  mutedBg: "#f3f6f9",
  cardBg: "#ffffff",
  success: "#2e7d32",
  danger: "#d32f2f",
  surface: "#ffffff",
} as const;

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: loopholeColors.primary,
      dark: loopholeColors.primaryDark,
      light: loopholeColors.primaryLight,
      contrastText: "#ffffff",
    },
    secondary: {
      main: loopholeColors.accentCyan,
      contrastText: loopholeColors.text,
    },
    success: { main: loopholeColors.success },
    error: { main: loopholeColors.danger },
    text: { primary: loopholeColors.text },
    background: { default: loopholeColors.mutedBg, paper: loopholeColors.surface },
  },
  typography: {
    fontFamily:
      '"Century Gothic", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    h1: { fontSize: "2.8rem", fontWeight: 800, lineHeight: 1.2 },
    h2: { fontSize: "1.8rem", fontWeight: 700 },
    h3: { fontSize: "1.25rem", fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
});

export default theme;
